








import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
  name: 'Footer',
  setup() {
    const now = ref(new Date().getFullYear());
    return {
      now
    };
  },
});
